import { createSelector } from 'reselect'

const organizationState = (state) => state.company

export const getOrganizationState = createSelector([organizationState], (organization) => organization)